<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-3">
            <h3 class="text-center mt-2 mal-text custom-title">{{ pageTitle }}</h3>
        </div>
    </div>

    <div class="section mt-1 mb-1">
        <ul class="nav nav-tabs lined" role="tablist">
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'registrations' }" href="javascript:void(0)" @click="activeTab = 'registrations'">
                    Registration List
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" :class="{ active: activeTab === 'centers' }" href="javascript:void(0)" @click="switchToCentersTab">
                    Exam Centre List
                </a>
            </li>
        </ul>
    </div>

    <!-- ============ TAB: Registration List ============ -->
    <template v-if="activeTab === 'registrations'">
        <!-- Filter Section with Accordion -->
        <div class="section inset mt-1 mb-1" v-if="showDistrictFilter || showZoneFilter || showUnitFilter">
            <div class="accordion" id="accordionKnowledgeExamFilter">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#knowledgeExamFilterAccordion"
                            aria-expanded="false"
                        >
                            <ion-icon name="filter-outline"></ion-icon>
                            Filter
                        </button>
                    </h2>
                    <div
                        id="knowledgeExamFilterAccordion"
                        class="accordion-collapse collapse"
                        :class="hasActiveFilters ? 'show' : ''"
                        data-bs-parent="#accordionKnowledgeExamFilter"
                    >
                        <div class="accordion-body">
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_district">District</label>
                                    <select class="form-control custom-select" v-model="filters.district" @change="onDistrictFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="filters.zone" @change="onZoneFilterChange">
                                        <option value="">---All---</option>
                                        <option v-for="z in zonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showUnitFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="filters.unit">
                                        <option value="">---All---</option>
                                        <option v-for="u in unitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearFilters">
                                        <ion-icon name="trash-bin-outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyFilters">
                                        <ion-icon name="search-outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="listview-title mt-0 mal-text custom-title">{{ $t('list') || 'ലിസ്റ്റ്' }}</div>

        <!-- Search -->
        <div class="search-section">
            <div class="search-box">
                <div class="input-wrapper">
                    <input
                        type="text"
                        class="form-control search-input"
                        v-model="search_query"
                        @input="handleSearch"
                        placeholder="പേര് / മൊബൈൽ തിരയൂ (Search by name or mobile)"
                        autocomplete="off"
                    />
                    <ion-icon name="search-outline" class="search-icon"></ion-icon>
                    <button type="button" class="clear-search-btn" v-if="search_query" @click="clearSearch">
                        <ion-icon name="close-circle"></ion-icon>
                    </button>
                </div>
            </div>
        </div>

        <div class="section text-center" v-if="loading_list">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="section">
            <div class="card">
                <h4 class="text-center mt-1 mal-text error-feedback" v-if="!loading_list && message">{{ message }}</h4>
            </div>
        </div>

        <ul class="listview image-listview inset text" v-if="!loading_list">
            <li v-for="(reg, index) in registrations" :key="reg.id">
                <div class="item-content">
                    <a href="javascript:void(0)" class="item">
                        <span class="sl-no">{{ pagination.from + index }}</span>
                        <img src="assets/img/sample/avatar/avatar1.png" alt="image" class="image" />
                        <div class="in">
                            <div class="min-width-50">
                                <b>{{ reg.name }}</b>
                                <div class="text-secondary small mal-text">{{ reg.parent_name }}</div>
                                <footer class="text-primary">
                                    {{ reg.mobile }}
                                    <span class="mal-text"><br>{{ reg.district_name }} &middot; {{ reg.zone_name }} &middot; {{ reg.unit_name }}</span>
                                    <span class="mal-text"><br>DOB: {{ reg.dob }}</span>
                                    <span v-if="reg.exam_center_name" class="mal-text text-success"><br>Exam Center: {{ reg.exam_center_name }}</span>
                                </footer>
                            </div>
                        </div>
                    </a>

                    <div class="card-button dropdown" @click.stop>
                        <button
                            type="button"
                            class="btn btn-link btn-icon"
                            data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + reg.id"
                            @click="showActionModel"
                        >
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>
                </div>
            </li>
        </ul>

        <div class="section mt-2" v-if="!loading_list">
            <vue-awesome-paginate
                v-if="pagination.total > 0"
                :total-items="pagination.total"
                :items-per-page="pagination.per_page"
                :max-pages-shown="3"
                v-model="pagination.current_page"
                :on-click="handlePageChange"
                :show-ending-buttons="true"
                :show-breakpoint-buttons="false"
            />
        </div>

        <!-- Action Sheet Modals -->
        <div v-for="reg in registrations" :key="'modal-' + reg.id">
            <div class="modal fade action-sheet" :id="'actionSheetInset' + reg.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ reg.name }}</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li>
                                    <a :href="'tel:' + reg.mobile" class="btn btn-list">
                                        <span><ion-icon name="call-outline"></ion-icon> Call</span>
                                    </a>
                                </li>
                                <li class="action-divider"></li>
                                <li>
                                    <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span><ion-icon name="close-outline"></ion-icon> Cancel</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- ============ TAB: Exam Centre List ============ -->
    <template v-if="activeTab === 'centers'">
        <div class="section mt-2 mb-1">
            <button type="button" class="btn btn-primary btn-block" @click="openAddCenterModal">
                <ion-icon name="add-outline"></ion-icon> Add Exam Center
            </button>
        </div>

        <!-- Filter Section with Accordion -->
        <div class="section inset mt-1 mb-1" v-if="showDistrictFilter || showZoneFilter || showUnitFilter">
            <div class="accordion" id="accordionExamCenterFilter">
                <div class="accordion-item">
                    <h2 class="accordion-header">
                        <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#examCenterFilterAccordion"
                            aria-expanded="false"
                        >
                            <ion-icon name="filter-outline"></ion-icon>
                            Filter
                        </button>
                    </h2>
                    <div
                        id="examCenterFilterAccordion"
                        class="accordion-collapse collapse"
                        :class="hasActiveCenterFilters ? 'show' : ''"
                        data-bs-parent="#accordionExamCenterFilter"
                    >
                        <div class="accordion-body">
                            <div v-if="showDistrictFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="center_filter_district">District</label>
                                    <select class="form-control custom-select" v-model="centerListFilters.district" @change="onCenterFilterDistrictChange">
                                        <option value="">---All---</option>
                                        <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showZoneFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="center_filter_zone">Zone</label>
                                    <select class="form-control custom-select" v-model="centerListFilters.zone" @change="onCenterFilterZoneChange">
                                        <option value="">---All---</option>
                                        <option v-for="z in centerFilterZonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div v-if="showUnitFilter" class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="center_filter_unit">Unit</label>
                                    <select class="form-control custom-select" v-model="centerListFilters.unit">
                                        <option value="">---All---</option>
                                        <option v-for="u in centerFilterUnitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;" @click="clearCenterFilters">
                                        <ion-icon name="trash-bin-outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;" @click="applyCenterFilters">
                                        <ion-icon name="search-outline"></ion-icon>
                                        Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section text-center" v-if="examCentersLoading">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div class="section mt-2 mb-2" v-if="!examCentersLoading && !examCenters.length">
            <div class="card">
                <h4 class="text-center mt-1 mal-text error-feedback">പരീക്ഷാ കേന്ദ്രങ്ങൾ ഒന്നും ചേർത്തിട്ടില്ല.</h4>
            </div>
        </div>

        <ul class="listview inset text" v-if="!examCentersLoading && examCenters.length">
            <li v-for="(center, index) in examCenters" :key="center.id">
                <div class="item-content">
                    <a href="javascript:void(0)" class="item">
                        <span class="sl-no">{{ index + 1 }}</span>
                        <div class="in">
                            <div class="min-width-50">
                                <b>{{ center.name }}</b>
                                <footer class="mal-text">
                                    {{ center.district_name }} &middot; {{ center.zone_name }} &middot; {{ center.unit_name }}
                                    <br>Coordinator: {{ center.coordinator_name }}
                                    <br>Invigilator ({{ invigilatorTypeLabel(center.invigilator_type) }}): {{ center.invigilator_display }}
                                    <br>Exam Time: {{ center.exam_time }}
                                    <br><span class="text-secondary" style="font-size: 11px;">Added by: {{ center.added_by_name }} &middot; {{ center.created_at }}</span>
                                </footer>
                            </div>
                        </div>
                    </a>
                    <div class="card-button dropdown" @click.stop>
                        <button
                            type="button"
                            class="btn btn-link btn-icon"
                            data-bs-toggle="modal"
                            :data-bs-target="'#centerActionSheet' + center.id"
                            @click="showActionModel"
                        >
                            <ion-icon name="ellipsis-horizontal"></ion-icon>
                        </button>
                    </div>
                </div>
            </li>
        </ul>

        <!-- Exam Center Action Sheet Modals -->
        <div v-for="center in examCenters" :key="'center-modal-' + center.id">
            <div class="modal fade action-sheet" :id="'centerActionSheet' + center.id" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ center.name }}</h5>
                        </div>
                        <div class="modal-body">
                            <ul class="action-button-list">
                                <li>
                                    <a href="javascript:void(0)" @click="openEditCenterModal(center)" class="btn btn-list" data-bs-dismiss="modal">
                                        <span><ion-icon name="create-outline"></ion-icon> Edit</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" @click="confirmDeleteCenter(center)" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span><ion-icon name="trash-outline"></ion-icon> Delete</span>
                                    </a>
                                </li>
                                <li class="action-divider"></li>
                                <li>
                                    <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                        <span><ion-icon name="close-outline"></ion-icon> Cancel</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <!-- Add Exam Center Modal -->
    <div class="modal fade action-sheet" id="addExamCenterModal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mal-text">{{ centerForm.id ? 'പരീക്ഷാ കേന്ദ്രം എഡിറ്റ് ചെയ്യുക' : 'പരീക്ഷാ കേന്ദ്രം ചേർക്കുക' }}</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <div class="form-group" v-if="showDistrictFilter">
                            <label class="label">District</label>
                            <select class="form-control custom-select" v-model="centerForm.district_id" @change="onCenterDistrictChange">
                                <option value="">---Select---</option>
                                <option v-for="d in districtsList" :key="d.id" :value="d.id">{{ d.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="showZoneFilter">
                            <label class="label">Zone</label>
                            <select
                                class="form-control custom-select"
                                v-model="centerForm.zone_id"
                                @change="onCenterZoneChange"
                                :disabled="showDistrictFilter && !centerForm.district_id"
                            >
                                <option value="">---Select---</option>
                                <option v-for="z in centerZonesList" :key="z.id" :value="z.id">{{ z.name }}</option>
                            </select>
                        </div>
                        <div class="form-group" v-if="showUnitFilter">
                            <label class="label">Unit</label>
                            <select class="form-control custom-select" v-model="centerForm.unit_id" :disabled="!centerForm.zone_id">
                                <option value="">---Select---</option>
                                <option v-for="u in centerUnitsList" :key="u.id" :value="u.id">{{ u.name }}</option>
                            </select>
                        </div>

                        <div class="form-group">
                            <label class="label">Center Name</label>
                            <input type="text" class="form-control" v-model="centerForm.name" placeholder="Center Name">
                        </div>

                        <div class="form-group" style="position: relative;">
                            <label class="label">Center Coordinator (Wisdom Students)</label>
                            <div v-if="centerForm.coordinator_display" class="picked-member-chip">
                                <span>{{ centerForm.coordinator_display }}</span>
                                <button type="button" @click="clearCoordinator">
                                    <ion-icon name="close-circle-outline"></ion-icon>
                                </button>
                            </div>
                            <template v-else>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="coordinatorSearch"
                                    @input="searchCoordinator"
                                    placeholder="പേര് / മൊബൈൽ തിരയൂ"
                                    :disabled="!centerForm.zone_id"
                                >
                                <div v-if="coordinatorResults.length" class="member-search-results">
                                    <div v-for="m in coordinatorResults" :key="m.id" @click="selectCoordinator(m)">
                                        <div class="name">{{ m.name }}</div>
                                        <div class="mobile">{{ m.mobile }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div class="form-group">
                            <label class="label">Center Invigilator</label>
                            <select class="form-control custom-select" v-model="centerForm.invigilator_type" @change="onInvigilatorTypeChange">
                                <option value="">---Select---</option>
                                <option value="madrasa_teacher">Madrasa Teacher</option>
                                <option value="youth">Youth</option>
                                <option value="org">ORG</option>
                            </select>
                        </div>

                        <template v-if="centerForm.invigilator_type === 'madrasa_teacher'">
                            <div class="form-group">
                                <label class="label">Invigilator Name</label>
                                <input type="text" class="form-control" v-model="centerForm.invigilator_name" placeholder="Name">
                            </div>
                            <div class="form-group">
                                <label class="label">Invigilator Mobile Number</label>
                                <input type="tel" class="form-control" v-model="centerForm.invigilator_mobile" placeholder="Mobile Number">
                            </div>
                        </template>
                        <div class="form-group" style="position: relative;" v-else-if="centerForm.invigilator_type === 'youth' || centerForm.invigilator_type === 'org'">
                            <label class="label">{{ centerForm.invigilator_type === 'youth' ? 'Youth' : 'ORG' }} Invigilator</label>
                            <div v-if="centerForm.invigilator_display" class="picked-member-chip">
                                <span>{{ centerForm.invigilator_display }}</span>
                                <button type="button" @click="clearInvigilator">
                                    <ion-icon name="close-circle-outline"></ion-icon>
                                </button>
                            </div>
                            <template v-else>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="invigilatorSearch"
                                    @input="searchInvigilator"
                                    placeholder="പേര് / മൊബൈൽ തിരയൂ"
                                    :disabled="!centerForm.zone_id"
                                >
                                <div v-if="invigilatorResults.length" class="member-search-results">
                                    <div v-for="m in invigilatorResults" :key="m.id" @click="selectInvigilator(m)">
                                        <div class="name">{{ m.name }}</div>
                                        <div class="mobile">{{ m.mobile }}</div>
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div class="form-group">
                            <label class="label">Exam Time</label>
                            <input type="time" class="form-control" v-model="centerForm.exam_time">
                        </div>

                        <p class="error-feedback" v-if="centerFormError">{{ centerFormError }}</p>
                        <button type="button" class="btn btn-primary btn-block btn-lg" :disabled="centerFormSaving" @click="submitExamCenter">
                            <span v-if="centerFormSaving" class="spinner-border spinner-border-sm me-1"></span>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from '../../services/user.service';
import $ from 'jquery';

const WING = { org: 1, youth: 2, students: 3 };

export default {
    name: 'WisdomExamRegistrationsList',
    data() {
        return {
            user_level: null,
            activeTab: 'registrations',

            // Registration List tab
            loading_list: false,
            message: '',
            search_query: '',
            search_timeout: null,
            registrations: [],
            pagination: { current_page: 1, total: 0, per_page: 20, from: 1 },

            filters: { district: '', zone: '', unit: '' },
            districtsList: [],
            zonesList: [],
            unitsList: [],

            // Exam Centre List tab
            examCenters: [],
            examCentersLoading: false,
            examCentersLoaded: false,
            centerListFilters: { district: '', zone: '', unit: '' },
            centerFilterZonesList: [],
            centerFilterUnitsList: [],

            // Add Exam Center form (separate district/zone/unit lists from the filter above, to
            // avoid the two cascading pickers stomping on each other's state)
            centerForm: {
                id: '',
                district_id: '',
                zone_id: '',
                unit_id: '',
                name: '',
                coordinator_member_id: '',
                coordinator_display: '',
                invigilator_type: '',
                invigilator_name: '',
                invigilator_mobile: '',
                invigilator_member_id: '',
                invigilator_display: '',
                exam_time: '',
            },
            centerZonesList: [],
            centerUnitsList: [],
            centerFormSaving: false,
            centerFormError: '',

            coordinatorSearch: '',
            coordinatorResults: [],
            invigilatorSearch: '',
            invigilatorResults: [],
            searchDebounce: null,
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        // District field: State only. Zone field: State + District. Unit field: State +
        // District + Zone (never at Unit level — it's already scoped to exactly one unit).
        // Shared by both the registration-list filter accordion and the Add Center form.
        showDistrictFilter() {
            return this.user_level === 1;
        },
        showZoneFilter() {
            return this.user_level === 1 || this.user_level === 2;
        },
        showUnitFilter() {
            return this.user_level === 1 || this.user_level === 2 || this.user_level === 3;
        },
        hasActiveFilters() {
            return this.filters.district || this.filters.zone || this.filters.unit;
        },
        hasActiveCenterFilters() {
            return this.centerListFilters.district || this.centerListFilters.zone || this.centerListFilters.unit;
        },
        pageTitle() {
            const level = this.user_level;
            let levelText = '';
            if (level === 1) levelText = 'സ്റ്റേറ്റ്';
            else if (level === 2) levelText = 'ജില്ല';
            else if (level === 3) levelText = 'മണ്ഡലം';
            else if (level === 4) levelText = 'യൂണിറ്റ്';
            return `${levelText ? levelText + ' ' : ''}വിസ്ഡം സ്റ്റുഡന്റ്സ് നോളജ് എക്സാം`;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.user_level = parseInt(this.$route.params.sub_level);
        this.loadFilterData();
        this.getRegistrationsList(1);
        if (this.$root.updateParent) {
            this.$root.updateParent('Knowledge Exam');
        }
    },
    methods: {
        showActionModel() {},
        invigilatorTypeLabel(type) {
            if (type === 'madrasa_teacher') return 'Madrasa Teacher';
            if (type === 'youth') return 'Youth';
            if (type === 'org') return 'ORG';
            return type || '-';
        },

        // ---- Registration List tab ----
        async loadFilterData() {
            try {
                if (this.user_level === 1) {
                    const resp = await UserService.authPostRequest('get-district-by-id', {});
                    this.districtsList = resp.data?.data?.list || [];
                }
                if (this.user_level === 2) {
                    const districtId = parseInt(this.$route.params.id);
                    if (districtId) {
                        const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: districtId });
                        this.zonesList = resp.data?.data?.list || [];
                    }
                }
                if (this.user_level === 3) {
                    const zoneId = parseInt(this.$route.params.id);
                    if (zoneId) {
                        const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: zoneId });
                        this.unitsList = resp.data?.data?.list || [];
                    }
                }
            } catch (e) {
                // ignore — filter dropdowns just stay empty
            }
        },
        async onDistrictFilterChange() {
            this.filters.zone = '';
            this.filters.unit = '';
            this.zonesList = [];
            this.unitsList = [];
            if (!this.filters.district) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.filters.district) });
            this.zonesList = resp.data?.data?.list || [];
        },
        async onZoneFilterChange() {
            this.filters.unit = '';
            this.unitsList = [];
            if (!this.filters.zone) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.filters.zone) });
            this.unitsList = resp.data?.data?.list || [];
        },
        applyFilters() {
            this.pagination.current_page = 1;
            this.getRegistrationsList(1);
        },
        clearFilters() {
            this.filters = { district: '', zone: '', unit: '' };
            this.zonesList = this.user_level === 1 ? [] : this.zonesList;
            this.unitsList = this.user_level <= 2 ? [] : this.unitsList;
            this.pagination.current_page = 1;
            this.getRegistrationsList(1);
        },
        getRegistrationsList(page = 1) {
            this.loading_list = true;
            UserService.authPostRequest('wisdom-exam/get-registrations', {
                sub_level_type: this.user_level,
                id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                page,
                per_page: 20,
                q: this.search_query || '',
                filter_district_id: this.filters.district ? parseInt(this.filters.district) : null,
                filter_zone_id: this.filters.zone ? parseInt(this.filters.zone) : null,
                filter_unit_id: this.filters.unit ? parseInt(this.filters.unit) : null,
            }).then(
                (response) => {
                    this.loading_list = false;
                    if (response.data.status === 'success' && response.data.data && response.data.data.list) {
                        const paginatedList = response.data.data.list;
                        this.registrations = paginatedList.data || [];
                        this.pagination = {
                            current_page: paginatedList.current_page || page,
                            total: paginatedList.total || 0,
                            per_page: paginatedList.per_page || 20,
                            from: paginatedList.from || 1,
                        };
                        this.message = this.registrations.length ? '' : 'രജിസ്ട്രേഷനുകൾ ഒന്നും കണ്ടെത്തിയില്ല.';
                    } else {
                        this.registrations = [];
                        this.message = response.data.message || 'രജിസ്ട്രേഷനുകൾ ഒന്നും കണ്ടെത്തിയില്ല.';
                    }
                },
                () => {
                    this.loading_list = false;
                    this.registrations = [];
                    this.message = 'രജിസ്ട്രേഷനുകൾ ലോഡ് ചെയ്യുന്നതിൽ പിശക്.';
                }
            );
        },
        handlePageChange(page) {
            this.pagination.current_page = page;
            this.getRegistrationsList(page);
        },
        handleSearch() {
            if (this.search_timeout) clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(() => {
                this.pagination.current_page = 1;
                this.getRegistrationsList(1);
            }, 500);
        },
        clearSearch() {
            this.search_query = '';
            this.pagination.current_page = 1;
            this.getRegistrationsList(1);
        },

        // ---- Exam Centre List tab ----
        switchToCentersTab() {
            this.activeTab = 'centers';
            if (!this.examCentersLoaded) {
                this.loadCenterFilterData();
                this.loadExamCenters();
            }
        },
        async loadCenterFilterData() {
            try {
                if (this.user_level === 2) {
                    const districtId = parseInt(this.$route.params.id);
                    if (districtId) {
                        const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: districtId });
                        this.centerFilterZonesList = resp.data?.data?.list || [];
                    }
                }
                if (this.user_level === 3) {
                    const zoneId = parseInt(this.$route.params.id);
                    if (zoneId) {
                        const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: zoneId });
                        this.centerFilterUnitsList = resp.data?.data?.list || [];
                    }
                }
            } catch (e) {
                // ignore — filter dropdowns just stay empty
            }
        },
        async onCenterFilterDistrictChange() {
            this.centerListFilters.zone = '';
            this.centerListFilters.unit = '';
            this.centerFilterZonesList = [];
            this.centerFilterUnitsList = [];
            if (!this.centerListFilters.district) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.centerListFilters.district) });
            this.centerFilterZonesList = resp.data?.data?.list || [];
        },
        async onCenterFilterZoneChange() {
            this.centerListFilters.unit = '';
            this.centerFilterUnitsList = [];
            if (!this.centerListFilters.zone) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.centerListFilters.zone) });
            this.centerFilterUnitsList = resp.data?.data?.list || [];
        },
        applyCenterFilters() {
            this.loadExamCenters();
        },
        clearCenterFilters() {
            this.centerListFilters = { district: '', zone: '', unit: '' };
            this.centerFilterZonesList = this.user_level === 1 ? [] : this.centerFilterZonesList;
            this.centerFilterUnitsList = this.user_level <= 2 ? [] : this.centerFilterUnitsList;
            this.loadExamCenters();
        },
        loadExamCenters() {
            this.examCentersLoading = true;
            UserService.authPostRequest('wisdom-exam/get-exam-centers', {
                sub_level_type: this.user_level,
                id: this.user_level === 1 ? null : parseInt(this.$route.params.id),
                filter_district_id: this.centerListFilters.district ? parseInt(this.centerListFilters.district) : null,
                filter_zone_id: this.centerListFilters.zone ? parseInt(this.centerListFilters.zone) : null,
                filter_unit_id: this.centerListFilters.unit ? parseInt(this.centerListFilters.unit) : null,
            }).then(
                (response) => {
                    this.examCentersLoading = false;
                    this.examCentersLoaded = true;
                    this.examCenters = response.data.status === 'success' ? (response.data.data.list || []) : [];
                },
                () => {
                    this.examCentersLoading = false;
                    this.examCentersLoaded = true;
                    this.examCenters = [];
                }
            );
        },
        resetCenterForm() {
            this.centerForm = {
                id: '',
                district_id: '', zone_id: '', unit_id: '',
                name: '',
                coordinator_member_id: '', coordinator_display: '',
                invigilator_type: '', invigilator_name: '', invigilator_mobile: '',
                invigilator_member_id: '', invigilator_display: '',
                exam_time: '',
            };
            this.centerZonesList = [];
            this.centerUnitsList = [];
            this.coordinatorSearch = '';
            this.coordinatorResults = [];
            this.invigilatorSearch = '';
            this.invigilatorResults = [];
            this.centerFormError = '';
        },
        async openAddCenterModal() {
            this.resetCenterForm();

            if (this.user_level === 2) {
                this.centerForm.district_id = parseInt(this.$route.params.id);
                await this.onCenterDistrictChange();
            } else if (this.user_level === 3) {
                this.centerForm.zone_id = parseInt(this.$route.params.id);
                await this.onCenterZoneChange();
            } else if (this.user_level === 4) {
                this.centerForm.unit_id = parseInt(this.$route.params.id);
                this.centerForm.zone_id = parseInt(this.currentUser?.zone_id) || '';
            }

            $('#addExamCenterModal').modal('show');
        },
        async openEditCenterModal(center) {
            this.resetCenterForm();
            this.centerForm.id = center.id;
            this.centerForm.name = center.name;
            this.centerForm.exam_time = center.exam_time;

            // Cascading loads first — onCenterDistrictChange/onCenterZoneChange reset
            // zone/unit/coordinator/invigilator as a side effect, so those get set after.
            if (this.user_level === 1) {
                this.centerForm.district_id = center.district_id;
                await this.onCenterDistrictChange();
                this.centerForm.zone_id = center.zone_id;
                await this.onCenterZoneChange();
                this.centerForm.unit_id = center.unit_id;
            } else if (this.user_level === 2) {
                this.centerForm.district_id = center.district_id;
                await this.onCenterDistrictChange();
                this.centerForm.zone_id = center.zone_id;
                await this.onCenterZoneChange();
                this.centerForm.unit_id = center.unit_id;
            } else if (this.user_level === 3) {
                this.centerForm.zone_id = center.zone_id;
                await this.onCenterZoneChange();
                this.centerForm.unit_id = center.unit_id;
            } else if (this.user_level === 4) {
                this.centerForm.unit_id = center.unit_id;
                this.centerForm.zone_id = center.zone_id;
            }

            this.centerForm.coordinator_member_id = center.coordinator_member_id;
            this.centerForm.coordinator_display = center.coordinator_name + (center.coordinator_mobile ? ' (' + center.coordinator_mobile + ')' : '');

            this.centerForm.invigilator_type = center.invigilator_type;
            if (center.invigilator_type === 'madrasa_teacher') {
                this.centerForm.invigilator_name = center.invigilator_name || '';
                this.centerForm.invigilator_mobile = center.invigilator_mobile || '';
            } else {
                this.centerForm.invigilator_member_id = center.invigilator_member_id;
                this.centerForm.invigilator_display = center.invigilator_display;
            }

            $('#addExamCenterModal').modal('show');
        },
        confirmDeleteCenter(center) {
            if (!window.confirm('ഈ പരീക്ഷാ കേന്ദ്രം നീക്കം ചെയ്യണോ? (Delete this exam center?)')) return;
            UserService.authPostRequest('wisdom-exam/delete-exam-center', { id: center.id }).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.loadExamCenters();
                    } else {
                        window.alert(response.data.message || 'Delete failed.');
                    }
                },
                (error) => {
                    window.alert((error.response && error.response.data && error.response.data.message) || 'Delete failed.');
                }
            );
        },
        async onCenterDistrictChange() {
            this.centerForm.zone_id = '';
            this.centerForm.unit_id = '';
            this.centerZonesList = [];
            this.centerUnitsList = [];
            if (!this.centerForm.district_id) return;
            const resp = await UserService.authPostRequest('get-zone-by-id', { district_id: parseInt(this.centerForm.district_id) });
            this.centerZonesList = resp.data?.data?.list || [];
        },
        async onCenterZoneChange() {
            this.centerForm.unit_id = '';
            this.centerUnitsList = [];
            this.clearCoordinator();
            this.clearInvigilator();
            if (!this.centerForm.zone_id) return;
            const resp = await UserService.authPostRequest('get-unit-by-id', { zone_id: parseInt(this.centerForm.zone_id) });
            this.centerUnitsList = resp.data?.data?.list || [];
        },
        onInvigilatorTypeChange() {
            this.centerForm.invigilator_name = '';
            this.centerForm.invigilator_mobile = '';
            this.clearInvigilator();
        },
        clearCoordinator() {
            this.centerForm.coordinator_member_id = '';
            this.centerForm.coordinator_display = '';
            this.coordinatorSearch = '';
            this.coordinatorResults = [];
        },
        clearInvigilator() {
            this.centerForm.invigilator_member_id = '';
            this.centerForm.invigilator_display = '';
            this.invigilatorSearch = '';
            this.invigilatorResults = [];
        },
        searchCoordinator() {
            if (this.searchDebounce) clearTimeout(this.searchDebounce);
            this.searchDebounce = setTimeout(async () => {
                if (!this.centerForm.zone_id) return;
                const resp = await UserService.authPostRequest('wisdom-exam/search-wing-members', {
                    zone_id: parseInt(this.centerForm.zone_id),
                    wing: WING.students,
                    search: this.coordinatorSearch,
                });
                this.coordinatorResults = resp.data?.data?.members || [];
            }, 350);
        },
        selectCoordinator(m) {
            this.centerForm.coordinator_member_id = m.id;
            this.centerForm.coordinator_display = m.name + (m.mobile ? ' (' + m.mobile + ')' : '');
            this.coordinatorResults = [];
        },
        searchInvigilator() {
            if (this.searchDebounce) clearTimeout(this.searchDebounce);
            this.searchDebounce = setTimeout(async () => {
                if (!this.centerForm.zone_id) return;
                const wing = this.centerForm.invigilator_type === 'youth' ? WING.youth : WING.org;
                const resp = await UserService.authPostRequest('wisdom-exam/search-wing-members', {
                    zone_id: parseInt(this.centerForm.zone_id),
                    wing,
                    search: this.invigilatorSearch,
                });
                this.invigilatorResults = resp.data?.data?.members || [];
            }, 350);
        },
        selectInvigilator(m) {
            this.centerForm.invigilator_member_id = m.id;
            this.centerForm.invigilator_display = m.name + (m.mobile ? ' (' + m.mobile + ')' : '');
            this.invigilatorResults = [];
        },
        submitExamCenter() {
            const f = this.centerForm;
            if (!f.name.trim()) { this.centerFormError = 'Center Name നൽകുക.'; return; }
            if (!f.unit_id) { this.centerFormError = 'Unit തിരഞ്ഞെടുക്കുക.'; return; }
            if (!f.coordinator_member_id) { this.centerFormError = 'Center Coordinator തിരഞ്ഞെടുക്കുക.'; return; }
            if (!f.invigilator_type) { this.centerFormError = 'Center Invigilator തരം തിരഞ്ഞെടുക്കുക.'; return; }
            if (f.invigilator_type === 'madrasa_teacher') {
                if (!f.invigilator_name.trim() || !f.invigilator_mobile.trim()) {
                    this.centerFormError = 'Invigilator Name, Mobile Number നൽകുക.';
                    return;
                }
            } else if (!f.invigilator_member_id) {
                this.centerFormError = 'Invigilator തിരഞ്ഞെടുക്കുക.';
                return;
            }
            if (!f.exam_time) { this.centerFormError = 'Exam Time നൽകുക.'; return; }

            this.centerFormError = '';
            this.centerFormSaving = true;
            const payload = {
                name: f.name.trim(),
                unit_id: parseInt(f.unit_id),
                coordinator_member_id: parseInt(f.coordinator_member_id),
                invigilator_type: f.invigilator_type,
                invigilator_name: f.invigilator_name,
                invigilator_mobile: f.invigilator_mobile,
                invigilator_member_id: f.invigilator_member_id ? parseInt(f.invigilator_member_id) : null,
                exam_time: f.exam_time,
            };
            const endpoint = f.id ? 'wisdom-exam/update-exam-center' : 'wisdom-exam/store-exam-center';
            if (f.id) payload.id = parseInt(f.id);
            UserService.authPostRequest(endpoint, payload).then(
                (response) => {
                    this.centerFormSaving = false;
                    if (response.data.status === 'success') {
                        $('#addExamCenterModal').modal('hide');
                        this.loadExamCenters();
                    } else {
                        this.centerFormError = response.data.message || 'സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല.';
                    }
                },
                (error) => {
                    this.centerFormSaving = false;
                    this.centerFormError = (error.response && error.response.data && error.response.data.message) || error.message || 'സേവ് ചെയ്യാൻ കഴിഞ്ഞില്ല.';
                }
            );
        },
    },
};
</script>

<style scoped>
.item-content {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    min-height: 60px;
    padding: 8px 0;
}
.item-content .item {
    flex: 1;
    min-width: 0;
    padding-right: 40px;
}
.card-button.dropdown {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 10;
}
.search-section {
    padding: 4px 16px 8px 16px;
}
.search-box .input-wrapper {
    position: relative;
}
.search-input {
    padding-left: 36px;
    padding-right: 36px;
}
.search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #6b7280;
}
.clear-search-btn {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    padding: 4px;
    color: #6b7280;
}
.picked-member-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #eef3ff;
    border-radius: 8px;
    padding: 8px 12px;
}
.picked-member-chip span {
    flex: 1;
    font-size: 13px;
    font-weight: 700;
    color: #1a418c;
}
.picked-member-chip button {
    background: none;
    border: none;
    color: #aaa;
    font-size: 18px;
    padding: 0;
}
.member-search-results {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-top: 4px;
    max-height: 150px;
    overflow-y: auto;
    background: #fff;
    position: absolute;
    width: 100%;
    z-index: 999;
}
.member-search-results > div {
    padding: 8px 12px;
    border-bottom: 1px solid #f0f0f0;
    cursor: pointer;
}
.member-search-results .name {
    font-size: 13px;
    font-weight: 600;
}
.member-search-results .mobile {
    font-size: 11px;
    color: #888;
}
</style>
